module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3c31c71459cc3b556ea5e293dd1a8093.png";